import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { DLModal } from 'appSrc/components/Shards';
import VideoImageForm from './form';
import style from './styles/style.module.css';

class VideoImageSelector extends PureComponent {
    render() {
        return (
            <DLModal title={ this.props.title }
            closeHandler={ this.props.closeHandler }
            className={ style.videoImageSelector }>
                <VideoImageForm yT={ this.props.yT } onSubmit={ this.props.onSubmit } initialValues={ this.props.initialValues } />
            </DLModal>
        );
    }
}
VideoImageSelector.propTypes = {
    title: PropTypes.string,
    closeHandler: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    yT: PropTypes.bool,
};
VideoImageSelector.defaultProps = {
    title: '',
    initialValues: {},
    yT: true,
};

export default VideoImageSelector;
